import React from "react"
import { useEffect } from "react"
import useSessions from "../../hooks/useSessions"
import SessionsLoadingSkeleton from "./SessionsLoadingSkeleton"
import OtherSessions from "./OtherSessions"
import CurrentSession from "./CurrentSession"
import { ReactComponent as CloseIcon } from "../../assets/images/x.svg"
import "./style.css"

const LogoutPopUp = ({ open, onClose, onLogoutCurrent, onLogoutAll, logoutAllLoading, logoutCurrentLoading }) => {
  const { sessions, currentSession, otherSessions, loading, refetch } = useSessions(false)

  useEffect(() => {
    if (open) {
      refetch()
    }
  }, [open, refetch])

  if (!open) return null

  return (
    <>
      <div style={{ zIndex: 999 }} className="overlay" />
      <div
        className="Team-PopUp-Container"
        style={{
          maxWidth: 424,
          padding: "24px",
          width: "min(90vw, 424px)",
          minWidth: "280px",


        }}
      >
        <div className="Team-PopUp-Header">
          <div />
          <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
        </div>

        <div className="popup-content-wrapper" >
          <div className="header-section">
            <p className="logout-main-title">Multiple Sessions Detected</p>
            <p className="logout-subtitle">
              You have {sessions?.length} active sessions. Choose how you'd like to log out.
            </p>
          </div>

          {loading ? (
            <SessionsLoadingSkeleton />
          ) : (
            <>
              {currentSession && (
                <CurrentSession currentSession={currentSession} />
              )}

              {otherSessions.length > 0 && (
                <OtherSessions otherSessions={otherSessions} />
              )}
            </>
          )}

          <div className="logout-button-container" style={{ width: "100%" }}>
            <button
              className="logout-all-sessions-button"
              type="button"
              onClick={onLogoutAll}
              disabled={logoutAllLoading || loading}
            >
              {logoutAllLoading ? "Loading..." : "Log out of all devices"}
            </button>
            <button
              className="logout-current-session-button"
              type="button"
              onClick={onLogoutCurrent}
              disabled={logoutCurrentLoading || loading}
              style={{ background: "#148dfd", color: "#fff", border: "none", }}
            >
              {logoutCurrentLoading ? "Loading..." : "Log out of current app"}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default LogoutPopUp
